<template>
  <span>{{fechaAlta }}</span>
</template>

<script>

export default {
  name: "CBandejaFechaantidadDiasTranscurridoComponente",
  props: {
    data: Object
  },
  data() {
    return {
      fechaAlta :null
    }
  },
  created() {
   this.fechaAlta = this.$formatoFechaHace(this.$moment(this.data['item'][this.data.field.key]));
  }
}
</script>

<style scoped>

</style>
